<template>
    <section class="mb-20 -mt-36">
        <div class="grid gap-6 sm:gap-8 md:gap-10 
             grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 z-10 relative">
            <NsServiceCard v-for="(feature, index) in features" :key="index" :image="feature.image"
                :title="feature.title" :description="feature.description" />
        </div>
    </section>
</template>

<script setup lang="ts">
const NsServiceCard = defineAsyncComponent(() =>
    import('~/components/NsServiceCard.vue')
)

const features = [
    {
        title: "Headless CMS Compatibility",
        description:
            "Easily integrate with your preferred headless CMS to create, manage, and deliver content seamlessly.",
        image: "/images/services-section/headless-cms.png",
    },
    {
        title: "SEO-Optimized",
        description:
            "Boost your search engine visibility with built-in SEO best practices and lightning-fast performance.",
        image: "/images/services-section/seo-optimized.png",
    },
    {
        title: "Responsive Design",
        description:
            "Deliver an exceptional shopping experience across all devices with a fully responsive design.",
        image: "/images/services-section/responsive-design.png",
    },
]
</script>
